export default __webpack_public_path__ + "static/quote-card-1-9f7eb504077fd47c8b126c982ae663242054e9510884263279e9180158513b48.png";